import moment from 'moment';

export const isValidEmailDomain = (email, domainList) => {
  const lowerEmail = email?.toLowerCase() || '';
  return domainList.some((domain) => lowerEmail.endsWith(domain.toLowerCase()));
};

export const showGlobalLoader = () => {
  const loader = document.createElement('div');
  loader.id = 'global-loader';
  loader.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255,255,255,0.9);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    font-size: 20px;
    color: #333;
  `;
  loader.innerText = 'Redirecting...';
  document.body.appendChild(loader);
};

export const isPastDatetime = (dateStr, timeStr) => {
  const combined = moment(`${dateStr} ${timeStr}`, 'DD-MM-YYYY HH:mm');
  return combined.isBefore(moment());
};

export function isOutsideRadius(
  officeLocation,
  pickupLocation,
  serviceableRadius
) {
  if (!officeLocation || !pickupLocation) return false;

  const toRad = (value) => (value * Math.PI) / 180;

  const R = 6371; // Earth radius in KM

  const lat1 = Number(officeLocation.latitude);
  const lon1 = Number(officeLocation.longitude);

  const lat2 = Number(pickupLocation.latitude);
  const lon2 = Number(pickupLocation.longitude);

  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);

  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c; // distance in KM

  return distance > serviceableRadius;
}

// export function isOutsideRadiusGoogle(officeLocation, pickupLocation, serviceableRadius) {
//   if (!officeLocation || !pickupLocation) return false;

//   const officeLatLng = new google.maps.LatLng(
//     Number(officeLocation.latitude),
//     Number(officeLocation.longitude)
//   );

//   const pickupLatLng = new google.maps.LatLng(
//     Number(pickupLocation.latitude),
//     Number(pickupLocation.longitude)
//   );

//   // Distance in METERS from Google Maps
//   const distanceInMeters = google.maps.geometry.spherical.computeDistanceBetween(
//     officeLatLng,
//     pickupLatLng
//   );

//   const distanceInKM = distanceInMeters / 1000;

//   console.log('Distance in KM:', distanceInKM);

//   return distanceInKM > serviceableRadius;
// }

export const generateTargetDates = (
  fromDate,
  toDate,
  weekOff = [],
  holidayList = []
) => {
  const weekMap = {
    SUN: 0,
    MON: 1,
    TUE: 2,
    WED: 3,
    THU: 4,
    FRI: 5,
    SAT: 6,
  };

  const weekOffNumbers = weekOff.map((day) => weekMap[day]);
  const holidays = new Set(holidayList);

  const start = new Date(fromDate);
  const end = new Date(toDate);

  const result = [];

  for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
    const iso = d.toISOString().slice(0, 10); // YYYY-MM-DD format

    // skip week-off days
    if (weekOffNumbers.includes(d.getDay())) continue;

    // skip holidays
    if (holidays.has(iso)) continue;

    result.push(iso);
  }

  return result;
};

export const getFormData = (object) =>
  Object.keys(object).reduce((formData, key) => {
    formData.append(key, object[key]);
    return formData;
  }, new FormData());
